const OrderTabsSelector = ({ currentView, setCurrentView }) => {
    return (
        <div className="tabs mb-4">
            <button className={`tab-button ${currentView === 'Bieżące' ? 'active' : ''}`} onClick={() => setCurrentView('Bieżące')}>
                Zamówienia bieżące
            </button>
            <button className={`tab-button ${currentView === 'Archiwalne' ? 'active' : ''}`} onClick={() => setCurrentView('Archiwalne')}>
                Zamówienia archiwalne
            </button>
            <button className={`tab-button ${currentView === 'WZ' ? 'active' : ''}`} onClick={() => setCurrentView('WZ')}>
                WZ bieżące
            </button>
        </div>
    )
}

export default OrderTabsSelector